<template>
  <div class="row mx-auto bg-light rounded">
    <div class="bg-white col rounded text-gray-15 px-5 py-4 m-2">
      <div class="font-20 font-weight-bold">
        {{ approvedDocumentsCount }}/{{ totalDocumentsCount }}
      </div>
      <div class="font-12">
        Cantidad de documentos aprobados
      </div>
    </div>
    <div class="bg-white col rounded text-gray-15 px-5 py-4 m-2">
      <div class="font-20 font-weight-bold">
        {{ expiredDocumentsCount }}/{{ totalDocumentsCount }}
      </div>
      <div class="font-12">
        Cantidad de documentos vencidos
      </div>
    </div>
  </div>
</template>
<script>
import rpContractDocumentStatus from '@/utils/constants/rpContractDocumentStatus.js';

export default {
  name: 'DocumentStatusBar',
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    now() {
      return new Date();
    },
    totalDocumentsCount() {
      return this.documents.length;
    },
    approvedDocumentsCount() {
      const approvedDocuments = this.documents.filter(
        (doc) => doc.statusId === rpContractDocumentStatus.Approved
      );
      return approvedDocuments.length;
    },
    expiredDocumentsCount() {
      const expiredDocumentCounts = this.documents.filter((item) => {
        return (
          item.documentExpirationDate != null &&
          Date.parse(item.documentExpirationDate) < new Date()
        );
      }).length;

      return expiredDocumentCounts;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';

.text-gray-15 {
  color: map-get($colors, 'gray-15');
}
</style>
